import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { ILov } from '../../../type_definitions/datatypes';

export enum ProcessingMode {
  STOCK_PARTNER = 'STOCK_P',
  VENDOR = 'V',
  DISTRIBUTOR = 'D',
  STOCK_DISTRIBUTOR = 'STOCK_D'
}

export enum ShippingFlow {
  PARTNER_CUSTOMER = 'PC',
  VENDOR_PARTNER_CUSTOMER = 'VPC',
  VENDOR_CUSTOMER = 'VC',
  DISTRIBUTOR_PARTNER_CUSTOMER = 'DPC',
  DISTRIBUTOR_CUSTOMER = 'DC',
  VENDOR_DISTRIBUTOR_PARTNER_CUSTOMER = 'VDPC',
  VENDOR_DISTRIBUTOR_CUSTOMER = 'VDC'
}

@Injectable()
export class BPProfilesOEMUtilService {

  public filterProcessingModes(list: ILov[], isDistributor?: boolean): ILov[] {
    if (isDistributor) {
      return _.filter(list, (procMode: ILov) => _.contains([ProcessingMode.STOCK_PARTNER, ProcessingMode.STOCK_DISTRIBUTOR, ProcessingMode.DISTRIBUTOR], procMode.id.toString()));
    } else {
      return _.filter(list, (procMode: ILov) => _.contains([ProcessingMode.STOCK_PARTNER, ProcessingMode.VENDOR], procMode.id.toString()));
    }
  }

  public filterShippingFlows(list: ILov[], processingMode: ProcessingMode | string): ILov[] {
    return _.filter(list, (shippingFlow: ILov) => {
      switch (processingMode) {
        case ProcessingMode.STOCK_PARTNER:
          return shippingFlow.id.toString() === ShippingFlow.PARTNER_CUSTOMER;
        case ProcessingMode.VENDOR:
          return _.contains([
            ShippingFlow.VENDOR_PARTNER_CUSTOMER,
            ShippingFlow.VENDOR_CUSTOMER
          ], shippingFlow.id.toString());
        case ProcessingMode.DISTRIBUTOR:
          return _.contains([
            ShippingFlow.VENDOR_PARTNER_CUSTOMER,
            ShippingFlow.VENDOR_DISTRIBUTOR_PARTNER_CUSTOMER,
            ShippingFlow.VENDOR_CUSTOMER,
            ShippingFlow.VENDOR_DISTRIBUTOR_CUSTOMER
          ], shippingFlow.id.toString());
        case ProcessingMode.STOCK_DISTRIBUTOR:
          return _.contains([
            ShippingFlow.DISTRIBUTOR_PARTNER_CUSTOMER,
            ShippingFlow.DISTRIBUTOR_CUSTOMER
          ], shippingFlow.id.toString());
        default:
          break;
      }
      return false;
    });
  }
}